import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { TableGenericViewControllerDelegate, TableGenericViewController, NavOptions } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { DengueRelatoryViewModel } from '../../Screen/DengueRelatory/DengueRelatoryViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';
import { toast } from 'react-toastify';

export class DengueRelatoryCoordinator implements IndexCoordinatorDelegate, TableGenericViewControllerDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
        ]
    }

    private routeTable(): JSX.Element {
        var arrayActions = new Array<NavOptions>()

        arrayActions.push({
            title: "Assinar",
            action: (navigation: any, item: any, component: React.Component) => { this.assinarVisitaDengue(item.id, component) },
            isSelection: true,
        })
        arrayActions.push({
            title: "Baixar PDF Frente",
            action: (navigation: any, item: any, component: React.Component) => { this.baixarPDF('frente', item.id, component) },
            isSelection: false,
        })
        arrayActions.push({
            title: "Baixar PDF Verso",
            action: (navigation: any, item: any, component: React.Component) => { this.baixarPDF('verso', item.id, component) },
            isSelection: false,
        })
        arrayActions.push({
            title: "Baixar PDF Resumo SUS",
            action: (navigation: any, item: any, component: React.Component) => { this.baixarPDF('resumo-sus', item.id, component) },
            isSelection: false,
        })
        arrayActions.push({
            title: "Amostras Coletadas PDF",
            action: (navigation: any, item: any, component: React.Component) => { this.baixarPDF('amostra-pdf', item.id, component) },
            isSelection: false,
        })
        arrayActions.push({
            title: "Amostras Coletadas XLSX",
            action: (navigation: any, item: any, component: React.Component) => { this.baixarPDF('amostra-xlsx', item.id, component) },
            isSelection: false,
        })

        var viewModel = new TableGenericViewModel("gepdengue")
        return (<ProtectedRoute requiredPermissions={['relatorios.dengue.*']} path="/:base/relatorios/dengue" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'relatorios.dengue.adicionar',
                    edit: 'relatorios.dengue.editar',
                    delete: 'relatorios.dengue.excluir',
                }}
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Relatório Dengue"}
                actions={arrayActions}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepdengue") {
            navigation.history.push(`dengue/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepdengue") {
            navigation.history.push(`dengue/cad/${idSelection}`);
            return;
        }
    }

    private assinarVisitaDengue(id: number, component: React.Component) {
        component.setState({ loading: true });
        var viewModel = new DengueRelatoryViewModel()
        viewModel.assinarPdf(id).then((rs) => {
            component.setState({ showLoading: false })
            toast.success("Visita da Dangue assinado com sucesso!", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }, (e) => {
            component.setState({ showLoading: false })
            toast.error(e.Mensagem, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    }
    private baixarPDF(tipo: 'frente' | 'verso' | 'resumo-sus' | 'amostra-pdf' | 'amostra-xlsx', id: number, component: React.Component) {
        component.setState({ loading: true });

        const viewModel = new DengueRelatoryViewModel();

        let metodo: () => Promise<any>;

        switch (tipo) {
            case 'frente':
                metodo = () => Promise.resolve(viewModel.baixarPDFFrente(id));
                break;
            case 'verso':
                metodo = () => Promise.resolve(viewModel.baixarPDFVerso(id));
                break;
            case 'resumo-sus':
                metodo = () => Promise.resolve(viewModel.baixarPDFResumoSemanalSUS(id));
                break;
            case 'amostra-pdf':
                metodo = () => Promise.resolve(viewModel.baixarPDFAmostraColetada(id));
                break;
            case 'amostra-xlsx':
                metodo = () => Promise.resolve(viewModel.baixarXLSXAmostraColetada(id));
                break;
            default:
                console.error('Tipo de relatório inválido');
                component.setState({ showLoading: false });
                return;
        }

        metodo().then(() => {
            component.setState({ showLoading: false });
            toast.success("PDF baixado com sucesso!", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }).catch((e) => {
            component.setState({ showLoading: false });
            toast.error(e?.Mensagem || "Erro ao baixar PDF", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    }


}